export enum CurrencyTypesEnum {
  NA = 0,
  Cost = 1,
  Price = 2,
}
